module.exports = __webpack_public_path__ + "icon_laina.db1a797b9200bf59d0d1.svg";